import type { FlightPoint } from '@/types/flight';

export const CSV_HEADER = 'timestamp,latitude,longitude,altitude';

export function pointToCsvRow(point: FlightPoint): string {
  return `${point.timestamp},${point.latitude.toFixed(8)},${point.longitude.toFixed(8)},${point.altitude != null ? point.altitude.toFixed(1) : ''}`;
}

export function pointsToCsv(points: FlightPoint[]): string {
  const rows = points.map(pointToCsvRow);
  return [CSV_HEADER, ...rows].join('\n');
}

export function csvToPoints(csv: string): FlightPoint[] {
  const lines = csv.trim().split('\n');
  const dataLines = lines[0]?.startsWith('timestamp') ? lines.slice(1) : lines;

  return dataLines
    .filter((line) => line.trim().length > 0)
    .map((line) => {
      const parts = line.split(',');
      const point: FlightPoint = {
        timestamp: Number(parts[0]),
        latitude: Number(parts[1]),
        longitude: Number(parts[2]),
        altitude: parts[3] !== '' && parts[3] !== undefined ? Number(parts[3]) : null,
      };
      if (parts[4] !== undefined && parts[4] !== '') {
        point.gforce = Number(parts[4]);
      }
      return point;
    });
}
